import { Injectable, signal } from '@angular/core'
import { Platform } from '@ionic/angular'
import { StorageService } from '../utils/storage.service'
import { AlertController } from '@ionic/angular/standalone'
import { TranslateService } from '@ngx-translate/core'

export type CoookiesState =
  | {
      state: 'idle'
    }
  | {
      state: 'not_already_set'
    }
  | {
      state: 'already_set'
      preferences: {
        necessary: boolean
        analytics: boolean
      }
    }
@Injectable({
  providedIn: 'root',
})
export class CookiesService {
  public cookiesState = signal<CoookiesState>({
    state: 'idle',
  })

  constructor(
    public platform: Platform,
    private storage: StorageService,
    private alertController: AlertController,
    private translate: TranslateService
  ) {}

  public async storePreferences(preferences: {
    necessary: boolean
    analytics: boolean
  }) {
    const state: CoookiesState = {
      state: 'already_set',
      preferences,
    }
    this.cookiesState.set(state)
    await this.storage.set('cookiesSettings', state)
  }

  async getPreferences() {
    return new Promise(async (resolve, reject) => {
      this.storage
        .get('cookiesSettings')
        .then(async (state: CoookiesState) => {
          if (state && state.state === 'already_set') {
            this.cookiesState.set(state)
          } else {
            this.cookiesState.set({ state: 'not_already_set' })
          }
          resolve(state)
        })
        .catch((e) => {
          reject(e)
        })
    })
  }

  async presentCookiesAlert() {
    const alert = await this.alertController.create({
      header: this.translate.instant('cookies.alert.header'),
      message: this.translate.instant('cookies.alert.message'),
      buttons: [
        {
          text: this.translate.instant('cookies.alert.close'),
          role: 'cancel',
        },
        {
          text: this.translate.instant('cookies.alert.accept'),
          handler: () => {
            const preferences = {
              necessary: true,
              analytics: true,
            }
            this.storePreferences(preferences)
          },
        },
      ],
    })
    await alert.present()
  }
}
